export enum HubChannel {
  NOTIFICATIONS = 'eclipsenotifications',
  NEW_FEEDBACK = 'mcfeedbacknew',
  DREAMSOFART = 'dreamsofart',
  DREAMSOFART_INPAINT = 'dreamsofartinpaint',
  CHATUNREAD = 'chatunread',
  BATCH_COMPLETE = 'batchcomplete',
}
